import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { TaskControllerApi } from "../../../services";
import { getConfigObject, useBaseData } from "../../../utils/utils";

export type Task = {
  assignByFirstName: string;
  assignById: string;
  assignByLastName: string;
  created: string;
  dueDate: string;
  uuid: string;
  patientBirthDate: Date;
  patientGender: string;
  assignToName: string;
  assignToGender: string;
  patientId: string;
  patientName: string;
  taskStatus: string;
  taskTitle: string;
  actions?: Record<string, string>;
};

export type TaskOption = {
  totalCount: number;
  tasks: Array<Task>;
};

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useTodaysTask = (xTENANTID?: string): useBaseData<TaskOption> => {
  return useQuery({
    queryKey: ["todays-task-type-list", xTENANTID],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new TaskControllerApi(getConfigObject())
        .getTodayTasks(xTENANTID)
        .then((res) => res?.data),
  });
};
